import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioParametrosReducer(state = initialState.relatorioParametros, action){
    switch(action.type) {
        case types.RELAT_PARAMETROS_PESQUISA:
            
            return action.relatorioParametros;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioParametrosReducer.js
 **/